import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import axios from 'axios';

Vue.config.productionTip = false;

// import 'bootstrap/dist/css/bootstrap.css'; // add this back if you need the original bootstrap
import 'bootstrap/dist/js/bootstrap';
import '@webops/web-framework-theme/dist/css/theme-app.min.css';
import '@webops/web-framework-theme/dist/js/theme.min'

axios.defaults.baseURL = 'https://rdap.apnic.net';

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
